import PropTypes from "prop-types";
import React from "react";

import "./imageCanvas.scss";

export class ImageCanvas extends React.Component {
  static propTypes = {
    src: PropTypes.string.isRequired
  };

  render() {
    return (
      <div
        data-component="imageCanvas"
        style={{ backgroundImage: `url(${this.props.src})` }}
      />
    );
  }
}
